'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TokenizedInput = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _analyticsEventComposers = require('@bibliocommons/analytics-event-composers');

var _utilsAnalytics = require('@bibliocommons/utils-analytics');

require('../styles/TokenizedInput.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var COMMA_KEY_CODE = 188;
var ENTER_KEY_CODE = 13;
var COMMA_LABEL = 'comma';
var ENTER_LABEL = 'enter';
var composeTriggerAddTagEvent = _analyticsEventComposers.tagsEventComposer.composeTriggerAddTagEvent;

var TokenizedInput = exports.TokenizedInput = function (_BcReactComponent) {
  _inherits(TokenizedInput, _BcReactComponent);

  function TokenizedInput(props) {
    _classCallCheck(this, TokenizedInput);

    var _this = _possibleConstructorReturn(this, (TokenizedInput.__proto__ || Object.getPrototypeOf(TokenizedInput)).call(this, props));

    _this.bindAll('handleInputBlur', 'handleInputChange', 'handleInputFocus', 'handleInputKeyDown', 'handleComponentClick');

    _this.state = {
      focused: false,
      inputValue: '',
      newTokenValue: ''
    };

    _this.componentRef = null;
    _this.inputRef = null;
    return _this;
  }

  _createClass(TokenizedInput, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.componentRef) {
        this.componentRef.addEventListener('click', this.handleComponentClick);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.componentRef) {
        this.componentRef.removeEventListener('click', this.handleComponentClick);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var newTokenValue = this.state.newTokenValue;
      var _props = this.props,
          isSaving = _props.isSaving,
          tokens = _props.tokens;

      if (newTokenValue && isSaving && !nextProps.isSaving) {
        this.setState({
          newTokenValue: '',
          inputValue: tokens.length === nextProps.tokens.length ? newTokenValue : ''
        });
      }
    }
  }, {
    key: 'handleInputFocus',
    value: function handleInputFocus() {
      this.setState({
        focused: true
      });
    }
  }, {
    key: 'handleInputBlur',
    value: function handleInputBlur() {
      this.setState({
        focused: false
      });
    }
  }, {
    key: 'handleInputChange',
    value: function handleInputChange(e) {
      this.setState({
        inputValue: e.target.value
      });
    }
  }, {
    key: 'handleInputKeyDown',
    value: function handleInputKeyDown(e) {
      if (this.state.newTokenValue || this.props.isSaving) {
        e.preventDefault();
        return;
      }

      if ([COMMA_KEY_CODE, ENTER_KEY_CODE].indexOf(e.keyCode) !== -1) {
        e.preventDefault();

        var inputValue = this.state.inputValue.trim();
        if (inputValue) {
          this.setState({
            newTokenValue: inputValue,
            inputValue: ''
          });

          // TODO: SHEL-286
          var eventLabel = ENTER_KEY_CODE === e.keyCode ? ENTER_LABEL : COMMA_LABEL;
          (0, _utilsAnalytics.sendAnalyticsEvents)(composeTriggerAddTagEvent(eventLabel));

          this.props.handleTokenSave(inputValue);
        }
      }
    }
  }, {
    key: 'handleComponentClick',
    value: function handleComponentClick() {
      if (this.inputRef && !this.containsFocusedElement()) {
        this.inputRef.focus();
      }
    }
  }, {
    key: 'containsFocusedElement',
    value: function containsFocusedElement() {
      return this.componentRef && this.componentRef !== document.activeElement && this.componentRef.contains(document.activeElement);
    }
  }, {
    key: 'renderTokens',
    value: function renderTokens() {
      var _props2 = this.props,
          tokens = _props2.tokens,
          getTokenKey = _props2.getTokenKey,
          renderToken = _props2.renderToken,
          renderNewToken = _props2.renderNewToken;


      var renderedTokens = tokens.map(function (token) {
        return _react2.default.createElement(
          'li',
          { key: getTokenKey(token), className: 'token-item' },
          renderToken(token)
        );
      });

      if (this.state.newTokenValue) {
        renderedTokens.push(_react2.default.createElement(
          'li',
          { key: 'new-token-item', className: 'token-item' },
          renderNewToken(this.state.newTokenValue)
        ));
      }

      if (renderedTokens.length || renderedTokens.size) {
        return _react2.default.createElement(
          'ul',
          { className: 'tokens-list' },
          renderedTokens
        );
      }

      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props3 = this.props,
          className = _props3.className,
          id = _props3.id,
          maxInputLength = _props3.maxInputLength;
      var _state = this.state,
          focused = _state.focused,
          inputValue = _state.inputValue;


      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('cp-tokenized-input', { focused: focused }, className), ref: function ref(el) {
            return _this2.componentRef = el;
          } },
        this.renderTokens(),
        _react2.default.createElement(
          'span',
          { className: 'new-token-input' },
          _react2.default.createElement('input', {
            id: id,
            type: 'text',
            autoComplete: 'off',
            autoCorrect: 'off',
            className: 'new-token-text-field',
            maxLength: maxInputLength,
            onChange: this.handleInputChange,
            onFocus: this.handleInputFocus,
            onBlur: this.handleInputBlur,
            onKeyDown: this.handleInputKeyDown,
            value: inputValue,
            ref: function ref(el) {
              return _this2.inputRef = el;
            } }),
          _react2.default.createElement(
            'span',
            { className: 'input-resizer', 'aria-hidden': true },
            inputValue,
            '\xA0'
          )
        )
      );
    }
  }]);

  return TokenizedInput;
}(_baseBcReactComponent2.default);

TokenizedInput.propTypes = {
  id: _react.PropTypes.string,
  className: _react.PropTypes.string,
  isSaving: _react.PropTypes.bool,
  maxInputLength: _react.PropTypes.number,
  tokens: _react.PropTypes.oneOfType([_react.PropTypes.array, _reactImmutableProptypes2.default.list]).isRequired,
  getTokenKey: _react.PropTypes.func.isRequired,
  renderToken: _react.PropTypes.func.isRequired,
  renderNewToken: _react.PropTypes.func.isRequired,
  handleTokenSave: _react.PropTypes.func.isRequired
};

TokenizedInput.defaultProps = {
  tokens: [],
  maxInputLength: 100,
  isSaving: false
};

exports.default = TokenizedInput;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-tokenized-input/lib/components/TokenizedInput.component.js
// module id = 1362
// module chunks = 1